import React from 'react';
import MainLayout from '../../components/MainLayout';

const ToolsPage = () => {
  return (
    <MainLayout>
    <div className='min-h-[50vh] font-bold italic text-center'>
      Tools page coming soon...
    </div>
    </MainLayout>
    
  )
}

export default ToolsPage
